import { gql } from '@apollo/client'

export default gql(`
    mutation createVirtualTag($name: String! $module: String $type: String $project: String $inputModule: String) {
            createVirtualTag(
            input: {
                name: $name
                module: $inputModule
                type: $type
            }
            project: $project
            module : $module
        ) {
            key
            type
            name
            module
            isTransferring
            assetCount
            mediaCount
            isError
        }
    }`
)
